import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { loadTeamReports } from "../../actions";
import styled from "styled-components";
import * as Icon from "react-feather";
import { Flex, Box } from "rebass";
import { BorderBottom } from "../../themes";
import { ArrowLeft } from "react-feather";

const rankings = [
  {
    rank: 1,
    name: "大内係",
    members: [{ name: "中島勇S" }, { name: "稲垣" }],
    estimatedNet: 41.9
  },
  {
    rank: 2,
    name: "櫻井係",
    members: [{ name: "中島勇S" }, { name: "稲垣" }],
    estimatedNet: 35.9
  },
  {
    rank: 3,
    name: "高橋係",
    members: [{ name: "中島勇S" }, { name: "稲垣" }],
    estimatedNet: 35.1
  },
  {
    rank: 4,
    name: "小林係",
    members: [{ name: "中島勇S" }, { name: "稲垣" }],
    estimatedNet: 33.4
  },
  {
    rank: 5,
    name: "河合係",
    members: [{ name: "中島勇S" }, { name: "稲垣" }],
    estimatedNet: 28.0
  }
];

class TeamReport extends Component {
  componentWillMount() {
    this.props.loadTeamReports();
  }

  render() {
    const { teamReports } = this.props;
    const { items } = teamReports;

    if (items.length <= 0) {
      return (
        <div className="container">
          <header>
            <ArrowLeft
              style={{ paddingBottom: "6px" }}
              onClick={() => this.props.history.goBack()}
            />
            <h1 style={{ marginLeft: 8 }}>係効率速報</h1>
          </header>

          <div style={{ padding: 16 }}>現在準備中!</div>
        </div>
      );
    }

    return (
      <div className="container">
        <header>
          <ArrowLeft
            style={{ paddingBottom: "6px" }}
            onClick={() => this.props.history.goBack()}
          />
          <h1 style={{ marginLeft: 8 }}>係効率速報</h1>
        </header>

        <RankingList>
          {items.map((ranking, i) => {
            return (
              <RankingItem key={i}>
                <Flex justifyContent="space-between">
                  <Box width={1 / 2}>
                    <Rank>{ranking.rank}</Rank>
                    <Name>{ranking.teamName}</Name>
                    {/* {ranking.members.map((member, i) => {
                      return (
                        <MemberName>
                          {i != 0 && ","}
                          {member.name}
                        </MemberName>
                      );
                    })} */}
                  </Box>
                  <Box width={1 / 2} style={{ textAlign: "center" }}>
                    <Value>{ranking.totalNet}</Value>
                  </Box>
                </Flex>
              </RankingItem>
            );
          })}
        </RankingList>
      </div>
    );
  }
}

const RankingList = styled.ul``;

const RankingItem = styled.li`
  padding: 16px;
  ${BorderBottom}
`;

const Rank = styled.span`
  color: rgb(101, 119, 134);
  margin-right: 16px;
  float: left;
  font-weight: bold;
`;

const Name = styled.div`
  margin-left: 5px;
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  width: 100%;
`;

const MemberName = styled.span`
  font-size: 12px;
  color: rgb(101, 119, 134);
`;

const Value = styled.span`
  color: rgb(101, 119, 134);
  margin-left: 5px;
  text-align: center;
  font-weight: bold;
`;

function mapStateToProps(state) {
  return {
    teamReports: state.teamReports
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      loadTeamReports
    }
  )(TeamReport)
);
